import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { MarkNotificationAsReadAPI } from '../../../../services/api/notification-api';
import './notification-row.scss';

const NotificationRow = ({ notification }) => {
    const history = useHistory();
    const data = notification ?? {};

    const getTimeString = (originalString = "") => {
        if (originalString === "") {
            return "";
        }

        const arr = originalString.split(" ");

        if (arr[0] == 1) {
            return arr[0] + " " + arr[1].substring(0, arr[1].length - 1) + " " + arr[2];
        }
        return originalString;
    };

    const notificationLink = async () => {
        try {
            const result = await MarkNotificationAsReadAPI(data.notificationId);

            if (result.status === 200) {
                if (data.link.includes("std")) {
                    const location = {
                        pathname: data.link,
                        state: {
                            buttons: [],
                            approve: true,
                            decline: true,
                            cancel: false,
                        },
                    };
                    history.push(location);
                } else {
                    history.push(data.link);
                }
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }
    };

    return (
        <tr
            onClick={() => notificationLink()}
            className={"notification-row notification-row-pointer " + (data.isRead === 1 ? "" : "unread-bold")}
        >
            <td className={"read-column " + (data.isRead === 1 ? "" : "read-column-blue")}></td>
            <td className={"sender-row " + (data.isRead === 1 ? "" : "unread-bold")}>{data.author}</td>
            <td className={"description-row " + (data.isRead === 1 ? "" : "unread-bold")}>{data.description}</td>
            <td className={"time-row " + (data.isRead === 1 ? "" : "unread-bold")}>{getTimeString(data.time)}</td>
        </tr>
    );
};

NotificationRow.propTypes = {
    notification: PropTypes.shape({
        notificationId: PropTypes.number,
        link: PropTypes.string,
        author: PropTypes.string,
        description: PropTypes.string,
        time: PropTypes.string,
        isRead: PropTypes.number,
    }),
};

export default memo(NotificationRow);
